<div class="shared-device-control">
  <div class="custom-input-wrapper shared-device-control__switch">
    <mat-slide-toggle
      class="mat-slide-toggle mat-slide-toggle_color_primary"
      [class.mat-slide-toggle_disabled]="passphraseControl?.disabled"
      color="primary"
      hideIcon="true"
      [formControl]="useSharedDeviceControl">
      <span class="form-label">{{ 'captive.form.my-device.shared-device' | translate }}</span>
    </mat-slide-toggle>

    <div class="info-wrapper shared-device-control__info-wrapper">
      <div class="info-icon" (click)="onOpenSharedDeviceInfo()"></div>
    </div>
  </div>

  <ng-container *ngIf="isShowPassphraseControl && passphraseControl">
    <app-shared-device-hint class="custom-input-wrapper" [text]="hintText" />

    <app-custom-input-text
      label="captive.form.my-device.passphrase"
      placeholder="captive.form.my-device.passphrase"
      key="passphrase"
      type="text"
      [submitted]="submitted"
      [errorsList]="errorsList"
      [control]="passphraseControl"
      (changedValue)="onChangedPassphrase($event)" />
  </ng-container>
</div>
